// extracted by mini-css-extract-plugin
export default {"breadcrub_container":"index_breadcrub_container__0ubDN","createdSearch":"index_createdSearch__aTR7X","custom_table":"index_custom_table__ODXIJ"};